import { render, staticRenderFns } from "./DialogConversationHistory.vue?vue&type=template&id=9c1bb804&scoped=true"
import script from "./DialogConversationHistory.vue?vue&type=script&lang=js"
export * from "./DialogConversationHistory.vue?vue&type=script&lang=js"
import style0 from "../style/conversation-history.scss?vue&type=style&index=0&id=9c1bb804&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1bb804",
  null
  
)

export default component.exports